import React from 'react';
import { Link } from 'react-router-dom';
import { FaCheck, FaPhoneAlt, FaHome } from 'react-icons/fa';
import './thank-you.css';

const ThankYou = () => {
  return (
    <div className="thank-you-page">
      <div className="thank-you-card">
        <p className="thank-you-brand">Dhanwalle</p>

        <div className="thank-you-icon-wrap" aria-hidden="true">
          <span className="thank-you-icon-ring" />
          <span className="thank-you-icon">
            <FaCheck />
          </span>
        </div>

        <h1 className="thank-you-title">Thank you!</h1>
        <p className="thank-you-message">
          Your loan application has been submitted successfully. Our team will review
          your details and get in touch shortly.
        </p>

        <div className="thank-you-next">
          <FaPhoneAlt />
          <span>Expect a call or SMS from us within 24 hours.</span>
        </div>

        <Link to="/" className="thank-you-home">
          <FaHome /> Back to Home
        </Link>
      </div>
    </div>
  );
};

export default ThankYou;
